module.exports = __webpack_public_path__ + "img/DE02218.14ab9310.png";